export default __webpack_public_path__ + "static/media/tried-grey.d85a9fc8.svg";